<template>
  <v-chip
    label small
    v-bind="$attrs"
  >
    <slot name="default"></slot>
  </v-chip>
</template>
<script>
  export default {
    name: 'status-badge'
  }
</script>
